import React, { useState, useEffect } from "react";
import { Button } from "react-materialize";
import $ from "jquery";
import config from "../../config";
import API from "../../utils/API";
import ModalDone from "../Container/modal.done";
import ModalError from "../Container/modal.error";
import ModalWarning from "../Container/modal.warning";
import Handle from "../Container/modal.handle";
import Func from "../../utils/Func";

export default function BtnAdd({ events, header }) {
  const [resData, setResData] = useState({ status: "", err: 0, err_msg: "" });
  const callbackEvent = {
    OnClose: function () {
      setResData({ status: "", err: 0, err_msg: "" });
    },
    OnComplete: function () {
      events.OnComplete();
    } };
  const handleEvents = {
    OnClose: function () {
      $("body").css({ overflow: "auto" });
      setResData({ status: "", err: 0, err_msg: "" });
    },
    OnSubmit: function () {
      Handle.loading.OnShow();
      let formData = Func.GetDataForm(
        $("#form-add").serializeArray(),
        "noarray"
      );
      const actionType = formData["action_type"];
      if (actionType == "department" || actionType == "division") {
        formData["organization"] = $(
          "#model-filter-inp-organization :selected"
        ).val();
        formData["department"] = $(
          "#model-filter-inp-department :selected"
        ).val();
        formData["level"] = $("#inp-req-level").val();
      } else {
        formData["organization"] = $(
          "#model-filter-inp-organization :selected"
        ).val();
        formData["country_code"] = $("#inp-req-country_code").val();
      }
      //console.log("FormData => ", formData, actionType);
      const mainFunc = async () =>
        await API.post("org/unit/setting/create", {
          params: ({
            userID: window.$user_profile.idu,
            formData: formData }) });
      mainFunc()
        .then((res) => {
          //console.log(res.data);
          Handle.loading.OnHide();
          const decrypt = (res?.data);
          // console.log("response=", decrypt);
          if (decrypt?.status === "success") {
            setResData(decrypt);
          } else {
            setResData({
              err: 1,
              err_msg: `Failes : ` + decrypt?.err_msg ?? "" });
          }
        })
        .catch((err) => {
          Handle.loading.OnHide();
          setResData({ err: 1, err_msg: "" });
        });
    } };
  //console.log("Edit Submit", resData);
  if ("err" in resData && resData.err === 1) {
    return (
      <ModalWarning
        header={header}
        content={resData.err_msg}
        callbackEvent={callbackEvent}
      />
    );
  } else if ("err" in resData && resData.err === 2) {
    return (
      <ModalError
        header={header}
        content={resData.err_msg}
        callbackEvent={callbackEvent}
      />
    );
  } else if (resData.status === "success") {
    return (
      <ModalDone
        header={header}
        content="This update is done!"
        callbackEvent={callbackEvent}
      />
    );
  }
  return (
    <Button
      className=""
      id=""
      node="button"
      waves="light"
      onClick={handleEvents.OnSubmit}
    >
      Submit
    </Button>
  );
}


